import { Menu } from 'lucide-react';
import { useAuthStore } from '../stores/auth';

export function Topbar({ onMenuClick }: { onMenuClick?: () => void }) {
  const user = useAuthStore((s) => s.user);

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center justify-between border-b border-zinc-800 bg-surface-1/80 px-4 backdrop-blur-lg sm:px-6 lg:px-8">
      <button
        type="button"
        onClick={onMenuClick}
        className="-ml-1 rounded-lg p-2 text-zinc-400 hover:bg-zinc-800 hover:text-zinc-200 lg:hidden"
        aria-label="Open navigation menu"
      >
        <Menu className="h-5 w-5" />
      </button>
      <div className="hidden lg:block" />
      <div className="flex items-center gap-4">
        {user && (
          <div className="flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-600 text-xs font-bold text-white uppercase">
              {(user.full_name || user.email || '?').charAt(0)}
            </div>
            <div className="hidden sm:block">
              <p className="text-sm font-medium text-zinc-200">{user.full_name}</p>
              <p className="text-xs text-zinc-500">{user.email}</p>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
